import { render } from "./CatalogFooter.vue?vue&type=template&id=6d6d310f&scoped=true"
import script from "./CatalogFooter.vue?vue&type=script&lang=js"
export * from "./CatalogFooter.vue?vue&type=script&lang=js"

import "./CatalogFooter.vue?vue&type=style&index=0&id=6d6d310f&lang=scss&scoped=true"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6d310f"]])

export default __exports__